import React from "react";
import { Box, Breadcrumbs, Chip, Divider } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Label from "../../../components/Label/Label";
import { plotTypeOptions } from "../visualization/constants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

const tabMap = {
  reports: "Reports",
  "create-report": "Create New Report",
  process: "Process",
  limits: "Limits",
  batches: "Batches",
  visualization: "Visualization",
  charts: "Charts",
  "audit-trail": "Audit Trail",
  genealogy: "Genealogy",
  create: "New Report",
  edit: "Edit Report",
  view: "View Report",
  dashboard: "Dashboard",
};

export default function BreadcrumbsBar({
  isUnitOpHide,
  showBack,
  onClickBack,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const { unitOfOperation } = useSelector(
    (state) => state.shared.productSitesUopValues || {},
  );

  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Check if last segment is a chart type
  const chartType =
    pathSegments.includes("charts") &&
    pathSegments[pathSegments.length - 1] !== "charts"
      ? pathSegments[pathSegments.length - 1]
      : null;

  const chartLabel =
    plotTypeOptions.find((opt) => opt.value === chartType)?.label || null;

  // Build breadcrumbs dynamically
  const crumbs = [
    { label: "SRM", color: "#717680" },
    ...pathSegments
      .map((seg) => {
        if (seg === "charts" && chartLabel) {
          return { label: chartLabel, color: "#717680" };
        }
        return tabMap[seg] ? { label: tabMap[seg], color: "#717680" } : null;
      })
      .filter(Boolean),
  ];

  // Append unitOfOperation crumb unless explicitly hidden or on restricted routes
  const hideUnitOpFor = ["reports", "create-report"];
  const shouldShowUnitOp =
    !isUnitOpHide &&
    unitOfOperation &&
    !pathSegments.some((seg) => hideUnitOpFor.includes(seg));

  if (shouldShowUnitOp) {
    crumbs.push({ label: unitOfOperation.name, color: "#154D8F" });
  }

  return (
    <Box px={3.5} py={1} display="flex" alignItems="center" gap={1}>
      {showBack && (
        <Chip
          icon={<ArrowBackIcon />}
          label="Back"
          onClick={onClickBack}
          clickable
          size="small"
          variant="filled"
          sx={{ padding: "0px 8px", fontSize: "12px" }}
        />
      )}

      <Breadcrumbs
        separator={<ArrowForwardIosIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {crumbs.map((crumb, idx) => (
          <Label
            key={idx}
            text={crumb.label}
            color={crumb.color}
            fontSize="12px"
            fontWeight="500"
          />
        ))}
      </Breadcrumbs>
    </Box>
  );
}
